import styled from 'styled-components';
import { rect, RectProps } from '../../../components/styles';

type Props = RectProps & {
  error?: boolean;
};

export const Input = styled.input<Props>`
  appearance: none;
  padding: ${({ theme }) => `${theme.spaces.m} ${theme.spaces.l}`};
  border: 1px solid ${({ theme }) => theme.borderColors.default};
  border-radius: ${({ theme }) => theme.radii.s};
  line-height: ${({ theme }) => theme.lineHeights.m};
  font-size: ${({ theme }) => theme.fontSizes.m};
  font-weight: ${({ theme }) => theme.fontWeights.bold};
  outline: 0;
  transition-duration: ${({ theme }) => theme.transitions.normal};
  ${rect};

  ${({ theme }) =>
    theme.screen.sp({
      fontSize: theme.fontSizes.l,
    })};

  &::placeholder {
    color: ${({ theme }) => theme.fontColors.placeholder};
    font-weight: ${({ theme }) => theme.fontWeights.normal};
  }

  &:invalid:focus {
    background: ${({ theme }) => theme.backgroundColors.error};
    border-color: ${({ theme }) => theme.borderColors.secondary};
    color: ${({ theme }) => theme.fontColors.pink};
  }

  ${({ theme, error = false }) => {
    if (!error) {
      return {
        background: theme.backgroundColors.default,
        color: theme.fontColors.default,
        '&:hover, &:focus': {
          borderColor: theme.borderColors.primary,
        },
      };
    } else {
      return {
        background: theme.backgroundColors.error,
        borderColor: theme.borderColors.secondary,
        color: theme.fontColors.pink,
      };
    }
  }}
`;
